
import React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

interface SleeveDesignEditorProps {
  onClose: () => void;
}

const SleeveDesignEditor: React.FC<SleeveDesignEditorProps> = ({ onClose }) => {
  const { toast } = useToast();
  
  const handleAddSleeveDesign = () => {
    toast({
      title: "Coming Soon!",
      description: "Sleeve design features will be available soon.",
    });
    onClose();
  };
  
  return (
    <div className="bg-white p-6 w-full max-w-4xl border rounded-md shadow-md">
      <div className="flex justify-between items-center mb-2">
        <div></div>
        <Button variant="ghost" size="icon" onClick={onClose}>
          <X className="h-5 w-5" />
        </Button>
      </div>
      
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold">Custom sleeve designs to make you stand out</h2>
        <p className="text-gray-600">Sleeve designs are available for orders of 6 or more with special pricing (shown at checkout).</p>
      </div>
      
      <div className="grid grid-cols-4 gap-6 mb-6">
        <div className="text-center">
          <div className="border rounded-md overflow-hidden mb-2">
            <img 
              src="/lovable-uploads/2aa2fc08-c233-4f6b-946a-4757ba4663fb.png" 
              alt="Standard sleeve design"
              className="w-full h-auto"
            />
          </div>
          <p className="font-medium">Standard</p>
        </div>
        
        <div className="text-center">
          <div className="border rounded-md overflow-hidden mb-2">
            <img 
              src="/lovable-uploads/d9c01a05-ba66-4b75-8796-99a29c14276f.png" 
              alt="Stacked sleeve design"
              className="w-full h-auto"
            />
          </div>
          <p className="font-medium">Stacked</p>
        </div>
        
        <div className="text-center">
          <div className="border rounded-md overflow-hidden mb-2">
            <img 
              src="/lovable-uploads/2271cc1b-627c-4888-9861-28ec63e731bc.png" 
              alt="Sentence Up sleeve design"
              className="w-full h-auto"
            />
          </div>
          <p className="font-medium">Sentence Up</p>
        </div>
        
        <div className="text-center">
          <div className="border rounded-md overflow-hidden mb-2">
            <img 
              src="/lovable-uploads/428aff6b-e0f7-4c0e-aac8-166072395ecc.png" 
              alt="Sentence Down sleeve design"
              className="w-full h-auto"
            />
          </div>
          <p className="font-medium">Sentence Down</p>
        </div>
      </div>
      
      <div className="text-center space-y-3">
        <Button 
          onClick={handleAddSleeveDesign} 
          className="bg-blue-600 hover:bg-blue-700 text-white px-8"
        >
          Add Sleeve Design
        </Button>
        
        <div>
          <Button variant="link" onClick={onClose} className="text-blue-600">
            No thanks, take me back to the Design Lab
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SleeveDesignEditor;
